import { render, staticRenderFns } from "./pending-info.vue?vue&type=template&id=6900d90c"
import script from "./pending-info.vue?vue&type=script&lang=ts"
export * from "./pending-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports